import { render, staticRenderFns } from "./YWK_MigBoardHeader.vue?vue&type=template&id=1500694c"
import script from "./YWK_MigBoardHeader.ts?vue&type=script&lang=ts&external"
export * from "./YWK_MigBoardHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports